import React from 'react';
import './toggle.css';
import GeckoFieldBase from '../_base';

class GeckoFieldToggle extends GeckoFieldBase {

    prepareValue() {
        return !this.value();
    }

    attrs() {
        return {
            id             : this.renderId(),
            [`aria-label`] : this.renderAriaLabel(),
            className      : 'toggle',
            type           : 'checkbox',
            disabled       : this.isDisabled(),
            onChange       : () => {},
            checked        : this.value()
        };
    }

    render() {
        return (
            <div>
                <input {...this.attrs()} />
                <label 
                    className="control-label" 
                    onClick={this.handleChange.bind(this)}>
                </label>
            </div>
        );
    }
    
}

export default GeckoFieldToggle;